import auth, { IRespondToMfa } from '../services/auth';
import resolveChallenge from './resolveChallenge';
import routing from '../services/routing';
import queryString from '../services/queryString';

export default async (formData: IRespondToMfa) => {
    const params = queryString.parse(routing.location.search);
    const payload = {
        ...formData,
        challengeName: params.challengeName as string,
    };
    const res = await auth.respondToMfa(payload);
    resolveChallenge(res.data);
};
